var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "card-content" }, [
      _c("h1", { staticClass: "title is-3 has-text-primary" }, [
        _c("i", { staticClass: "fas fa-play-circle" }),
        _vm._v(" Evento: " + _vm._s(_vm.resource.nombre)),
      ]),
      _vm._v(" "),
      _c("h1", { staticClass: "subtitle is-5" }, [
        _vm._v(
          "Por favor, revise los datos del evento antes de confirmar su ejecución."
        ),
      ]),
      _vm._v(" "),
      _c(
        "table",
        { staticClass: "table is-narrow is-fullwidth is-marginless" },
        [
          _c("tbody", [
            _c("tr", [
              _c("th", [_vm._v("Nombre del evento")]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.resource.nombre))]),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("Posibles estados iniciales")]),
              _vm._v(" "),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "tags" },
                  _vm._l(_vm.resource.estados_iniciales, function (estado) {
                    return _c(
                      "p",
                      { key: estado, staticClass: "tag is-small is-primary" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.unidadCompuesta.serie_documental.estados[estado]
                          )
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("Estado final")]),
              _vm._v(" "),
              _c("td", [
                _vm.unidadCompuesta.serie_documental.estados[
                  _vm.resource.estado_final
                ]
                  ? _c("p", { staticClass: "tag is-primary" }, [
                      _vm._v(
                        _vm._s(
                          _vm.unidadCompuesta.serie_documental.estados[
                            _vm.resource.estado_final
                          ]
                        )
                      ),
                    ])
                  : _c("p", [
                      _vm._m(0),
                      _vm._v(" \n                "),
                      _c("span", { staticClass: "is-size-7" }, [
                        _vm._v("Se mantiene el mismo estado"),
                      ]),
                    ]),
              ]),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("Areas habilitadas")]),
              _vm._v(" "),
              _c(
                "td",
                [
                  _vm.resource.areas_habilitadas == null
                    ? _c("p", { staticClass: "is-size-7" }, [
                        _c("i", {
                          staticClass: "fas fa-check has-text-primary",
                        }),
                        _vm._v(
                          " Todas las areas pueden ejecutar el evento\n              "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.resource.areas_habilitadas, function (area) {
                    return _c(
                      "p",
                      { key: area, staticClass: "tag is-primary" },
                      [
                        _c("i", { staticClass: "fas fa-tag" }),
                        _vm._v(
                          "\n                  " +
                            _vm._s(
                              _vm.areasOrganizacion.find((a) => a.id == area)
                                .nombre
                            ) +
                            "\n              "
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "table",
        {
          staticClass: "table is-narrow is-fullwidth is-marginless is-bordered",
        },
        [
          _c(
            "tbody",
            [
              _vm._m(1),
              _vm._v(" "),
              _vm._l(_vm.resource.acciones, function (accion, index) {
                return _c("tr", { key: index }, [
                  _c("td", [
                    _c("p", [_c("b", [_vm._v(_vm._s(accion.descripcion))])]),
                    _vm._v(" "),
                    _c("p", { staticClass: "is-size-7" }, [
                      _vm._v(
                        _vm._s(
                          _vm.getOperacion(accion.documento_operacion_id).nombre
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    _vm._l(accion.parametros, function (p, index) {
                      return _c("p", { key: index, staticClass: "is-size-7" }, [
                        _c("b", [_vm._v(_vm._s(index))]),
                        _vm._v(
                          "\n                : " +
                            _vm._s(p) +
                            "\n              "
                        ),
                      ])
                    }),
                    0
                  ),
                ])
              }),
              _vm._v(" "),
              _vm.resource.acciones.length === 0
                ? _c("tr", [
                    _c(
                      "td",
                      { staticClass: "is-mono", attrs: { colspan: "2" } },
                      [
                        _vm._v(
                          "El evento no requiere de acciones en particular"
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("div", { staticClass: "notification is-dark has-text-centered" }, [
        _c(
          "h1",
          { staticClass: "subtitle is-5 has-text-white is-marginless" },
          [
            _vm._v(
              "¿Desea ejecutar el evento " + _vm._s(_vm.resource.nombre) + "?"
            ),
          ]
        ),
        _vm._v(" "),
        _vm._m(2),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("div", { staticClass: "buttons is-centered" }, [
          _c(
            "button",
            {
              staticClass: "button is-primary",
              on: {
                click: function ($event) {
                  return _vm.ejecutarEvento(_vm.resource.id)
                },
              },
            },
            [
              _c("i", { staticClass: "fas fa-play-circle fa-fw" }),
              _vm._v(" Ejecutar evento\n          "),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "tag is-primary" }, [
      _c("i", { staticClass: "fas fa-asterisk" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("th", { staticClass: "is-selected" }, [_vm._v("Acciones requeridas")]),
      _vm._v(" "),
      _c("th", { staticClass: "is-selected" }, [_vm._v("Parametros")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "help has-text-warning" }, [
      _c("i", { staticClass: "fas fa-info-circle" }),
      _vm._v(
        " IMPORTANTE: Durante la ejecución de un evento, no habra marcha atras, siendo obligatorio la finalización del mismo.\n        "
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }